import { render, staticRenderFns } from "./LicenseOfferRequests.vue?vue&type=template&id=25b4173b&scoped=true&"
import script from "./LicenseOfferRequests.vue?vue&type=script&lang=js&"
export * from "./LicenseOfferRequests.vue?vue&type=script&lang=js&"
import style0 from "./LicenseOfferRequests.vue?vue&type=style&index=0&id=25b4173b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b4173b",
  null
  
)

export default component.exports